/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlWelcomeTokenResponse
 */
export interface ControlWelcomeTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlWelcomeTokenResponse
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlWelcomeTokenResponse
     */
    user_email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlWelcomeTokenResponse
     */
    welcome_token: string;
    /**
     * 
     * @type {string}
     * @memberof ControlWelcomeTokenResponse
     */
    expires_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlWelcomeTokenResponse
     */
    policy_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlWelcomeTokenResponse
     */
    is_new: boolean;
}

/**
 * Check if a given object implements the ControlWelcomeTokenResponse interface.
 */
export function instanceOfControlWelcomeTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_email" in value;
    isInstance = isInstance && "welcome_token" in value;
    isInstance = isInstance && "expires_at" in value;
    isInstance = isInstance && "is_new" in value;

    return isInstance;
}

export function ControlWelcomeTokenResponseFromJSON(json: any): ControlWelcomeTokenResponse {
    return ControlWelcomeTokenResponseFromJSONTyped(json, false);
}

export function ControlWelcomeTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlWelcomeTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'user_email': json['user_email'],
        'welcome_token': json['welcome_token'],
        'expires_at': json['expires_at'],
        'policy_id': !exists(json, 'policy_id') ? undefined : json['policy_id'],
        'is_new': json['is_new'],
    };
}

export function ControlWelcomeTokenResponseToJSON(value?: ControlWelcomeTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'user_email': value.user_email,
        'welcome_token': value.welcome_token,
        'expires_at': value.expires_at,
        'policy_id': value.policy_id,
        'is_new': value.is_new,
    };
}

